import React from 'react';

const requestInfoContext = React.createContext({});
export default requestInfoContext;